import React from 'react';
import GitInfoPage from './pages/GitInfoPage';
import CustomIndicatorsExplorer from './pages/CustomIndicatorsExplorer';
import ListMeasurementUnits from './pages/ListMeasurementUnits';
import ListMUnitsCategories from './pages/ListMUnitsCategories';
import QualitativeTypes from './pages/QualitativeTypes';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';

const indRoutes = [
    { path: 'git-info', element: <GitInfoPage />, visibility: 'private' },
    { path: 'custom-explorer', element: <CustomIndicatorsExplorer />, visibility: 'private' },
    { path: 'measurement-units', element: <ListMeasurementUnits />, visibility: 'private' },
    { path: 'mu-categories', element: <ListMUnitsCategories />, visibility: 'private' },
    { path: 'qual-types', element: <QualitativeTypes />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BIndicators = () => {
    return <B2BRoutesModule routes={indRoutes} />;
}

export default B2BIndicators;